﻿import { setupSardine, updateSardineConfig, getDeviceResponse, getSardineConfig, unbind, bind } from '@sardine-ai/web-sdk';

function initialize(options) {
    setupSardine({
        clientId: options.clientId,
        environment: options.environment || 'sandbox',
        region: options.region || 'us',
        apiSubdomain: options.apiSubdomain || undefined,
        pixelSubdomain: options.pixelSubdomain || undefined,
    });
}

async function configure(config) {
    await updateSardineConfig({
        sessionKey: config.sessionKey,
        flow: config.flow,
        customerId: config.customerId,
        enableBiometrics: config.enableBiometrics !== undefined ? config.enableBiometrics : true,
        enablePortScanning: false,
    });
}

export { initialize, configure, getDeviceResponse, getSardineConfig, unbind, bind };